import * as Schema from "effect/Schema";
import { freezeMetadata, ValidationError } from "@linempo/kernel";
import { decodeProject } from "@linempo/project-domain";
import { DEFAULT_EXPORT_SETTINGS, ExportSettings, MAX_EXPORT_DURATION_MS, RenderError, WorkerError } from "@linempo/render-domain";
export const idleJob = () => ({ status: "idle", jobId: null, progress: null, error: null });
export const emptySelection = () => ({ assetIds: [], activeRegion: null, assetId: null, clipId: null, cueIds: [], anchorCueId: null });
export const initialState = () => freezeMetadata({
    project: null, savedRevision: null, settings: DEFAULT_EXPORT_SETTINGS,
    prepare: { ...idleJob(), plan: null }, export: { ...idleJob(), artifact: null, locked: false },
    animations: { inspections: [], checking: false, missingInUse: [] },
    generation: { status: "idle", startedAtMs: null, finishedAtMs: null, items: [], activeAnimationId: null, completed: 0, total: 0, estimatedRemainingMs: null },
    preview: { target: { _tag: "timeline" }, timelineTimeMs: 0, requestedTimeMs: 0, frame: null, seeking: false, playing: false, updating: false },
    selection: emptySelection(), zoom: 80,
    history: { canUndo: false, canRedo: false, undoCount: 0, redoCount: 0 },
    save: { status: "idle", error: null }, workspace: { pending: 0, importing: false, switching: false }, error: null, disposed: false,
});
export const workerError = (reason, message) => new WorkerError({ reason, message });
export function asRenderError(error) {
    if (Schema.is(RenderError)(error))
        return error;
    return workerError("protocol", error instanceof Error ? error.message : String(error));
}
export function checkedProject(input) {
    const project = decodeProject(input);
    if (project.durationMs > MAX_EXPORT_DURATION_MS)
        throw new ValidationError({ path: "edit.time", message: "工程最长为 10 分钟；请调整输入后重试。" });
    return project;
}
export function checkedSettings(input) {
    try {
        return freezeMetadata(Schema.decodeUnknownSync(ExportSettings)(input));
    }
    catch (error) {
        throw new ValidationError({ path: "exportSettings", message: String(error) });
    }
}
